import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { handleError } from 'reducers/ErrorReducer';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from 'components/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import { searchVehicleTowings } from 'reducers/SearchReducer';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import {
  showAddAttachment,
  showAddVehicle,
  showReport,
  showEditVehicle,
} from 'reducers/DialogsReducer';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import XGrid3 from 'components/XGrid3';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import { Redirect } from 'react-router-dom';
import LocalPrintshopRoundedIcon from '@material-ui/icons/LocalPrintshopRounded';
import { Alert } from '@material-ui/lab';
import TextField2 from 'components/TextField2';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns';
import RecordLimitAlert from 'Search/components/RecordLimitAlert';
const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
    '& > div': {
      marginRight: theme.spacing(2),
    },
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  filter: {
    width: '100%',
    marginBottom: '8px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    '& button': {
      marginLeft: 8,
    },
  },
  panel: {
    '& .MuiDataGridPanelFooter-root': {
      display: 'none',
    },
  },
  search: {
    width: 450,
    marginRight: 8,
  },
}));

const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);

const defaultColumns = [
  'VehicleID',
  'PlateNumber',
  'PlateState',
  'Year',
  'Make',
  'Model',
  'PrimaryColor',
  {
    field: 'IsTowed',
    renderCell: bool,
    format: 'bool',
  },
  'PlaceID',
  'PlaceName',
  'PersonID',
  'FullName',
  'EventID',
  'Created',
  'CreatedBy',
  'UpdatedBy',
  'IsDeleted',
  'Deleted',
  'DeletedBy',
  'DeletedIP',
];

function VehicleTowing(props) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState(null);
  const [loaded, setLoaded] = useState(true);
  const [towingColumns, setTowingColumns] = useState(defaultColumns);
  const permissions = getFullPermissions('globals', 'Vehicles', 'any');
  const [printFlag, setPrintFlag] = useState(false);
  const [text, setText] = useState('');
  const [dateFrom, setDateFrom] = useState(new Date());
  const [dateTo, setDateTo] = useState(new Date());
  const [rowCount, setRowCount] = useState(0);
  const limit = 1000;
  const [page, setPage] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (rows.length === rowCount) setShowAlert(false);
    else if (rows.length >= limit) setShowAlert(true);
  }, [rows, rowCount]);
  const search = async (offset = 0, mergeRows = false) => {
    setLoaded(false);
    searchVehicleTowings(text, dateFrom, dateTo, offset, limit)
      .then((result) => {
        const nextStartingIndex = rows.length;
        //adding total number of rows
        result.length ? setRowCount(result[0].Count) : setRowCount(0);
        //TRUE means, fetching next 1000 rows
        //so merging new rows with existing
        if (mergeRows)
          setRows((prevState) => [...prevState, ...processData(result, nextStartingIndex)]);
        else {
          setRows(processData(result));
          setPage(0); //resetting page
        }
      })
      .catch(props.handleError)
      .finally(() => setLoaded(true));
  };

  const processData = (data, nextStartingIndex = 0) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: idx + nextStartingIndex,
      };
    });
  };

  const viewDetails = () => {
    let item = rows.find((row) => row.id === selection);
    if (!item) return;
    props.showReport({
      id: 33,
      data: { ptsVehicleID: item.ptsVehicleID },
      title: 'Vehicle Towing Details',
    });
  };

  const addVehicle = () => {
    props.showAddVehicle();
  };

  const addAttachment = () => {
    const item = rows.find((row) => row.id === selection);
    const { ptsVehicleID } = item;
    props.showAddAttachment({ id: ptsVehicleID, type: 'Vehicle' });
  };

  const editVehicle = () => {
    let item = rows.find((row) => row.id === selection);
    if (!item) return;
    props.showEditVehicle(item.ptsVehicleID);
  };

  const handlePrintClick = () => {
    setPrintFlag(true);
    setTimeout(() => setPrintFlag(false), 1000);
  };

  const onPageChange = () => {
    const offset = (page + 1) * limit;
    const mergingRows = true;
    search(offset, mergingRows);
    setPage(page + 1);
  };
  if (!permissions.Read) return <Redirect to="/" />;

  const renderSearch = () => {
    const onChange = (ev, val) => setText(val);
    const onKeyDown = (ev) => ev.key === 'Enter' && search();
    return (
      <TextField2
        value={text}
        onChange={onChange}
        type="search"
        className={classes.search}
        onKeyDown={onKeyDown}
        compact="true"
      />
    );
  };

  const renderDateFrom = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          className="mr-2"
          disableToolbar
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          label="Date From"
          value={dateFrom}
          onChange={(date) => setDateFrom(date)}
          maxDate={dateTo}
          autoOk
          size="small"
        />
      </MuiPickersUtilsProvider>
    );
  };

  const renderDateTo = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          className="mr-2"
          disableToolbar
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          label="Date To"
          value={dateTo}
          onChange={(date) => setDateTo(date)}
          minDate={dateFrom}
          autoOk
          size="small"
        />
      </MuiPickersUtilsProvider>
    );
  };

  const renderSaveBtn = () => {
    return (
      <div className={classes.btn}>
        <Button onClick={() => search()} variant="outlined">
          Search
        </Button>
      </div>
    );
  };

  return (
    <div>
      <h5>Vehicle Towings History</h5>
      <div className={classes.filterWrap}>
        <div className={classes.filterWrap}>
          {renderSearch()}
          {renderDateFrom()}
          {renderDateTo()}
          {renderSaveBtn()}
        </div>
        <div className={classes.actions}>
          {permissions.Create && (
            <Tooltip title="Add vehicle">
              <Fab onClick={addVehicle} size="small" color="secondary">
                <AddIcon />
              </Fab>
            </Tooltip>
          )}
          <Tooltip title="Print list">
            <Fab size="small" color="secondary" onClick={handlePrintClick}>
              <LocalPrintshopRoundedIcon />
            </Fab>
          </Tooltip>
          {selection !== null && (
            <>
              {permissions.Edit && (
                <Tooltip title="Edit Vehicle">
                  <Fab className="ml-2" size="small" color="secondary" onClick={editVehicle}>
                    <EditIcon />
                  </Fab>
                </Tooltip>
              )}
              <Tooltip title="View details">
                <Fab className="ml-2" size="small" color="secondary" onClick={viewDetails}>
                  <InfoIcon />
                </Fab>
              </Tooltip>
              <Tooltip title="Add attachment">
                <Fab className="ml-2" color="secondary" size="small" onClick={addAttachment}>
                  <AttachFileIcon />
                </Fab>
              </Tooltip>
            </>
          )}
        </div>
      </div>
      {showAlert && (
        <RecordLimitAlert
          handleNextPage={onPageChange}
          rowCount={rowCount}
          currentRows={rows.length}
        />
      )}
      <XGrid3
        name="Vehicle Towings"
        columns={towingColumns}
        setColumns={setTowingColumns}
        rows={rows}
        loading={!loaded}
        setSelection={setSelection}
        printFlag={printFlag}
        viewDetails={viewDetails}
        refresh={search}
      />
    </div>
  );
}

export default connect(null, {
  handleError,
  showReport,
  showAddAttachment,
  showAddVehicle,
  showEditVehicle,
})(VehicleTowing);
